import React from 'react';

import { StarSolidIcon } from '../../../shared/icons/icons';
import { RatingSummary } from '../star-bar-rating';

import styles from './star-bar-rating-item.scss';

interface StarBarRatingItemProps {
  onBarClick?: (ratingSummary: RatingSummary) => void;
  ratingSummary: RatingSummary;
  totalCount: number;
}

function StarBarRatingItem(props: StarBarRatingItemProps) {
  const { onBarClick, ratingSummary, totalCount } = props;

  const ratingCount = ratingSummary.count ? ratingSummary.count : 0;
  const fillPercentage = (ratingCount / totalCount) * 100;

  function handleClick() {
    if (typeof onBarClick === 'function') {
      onBarClick(ratingSummary);
    }
  }

  return (
    <div className={styles['rating']}>
      <span className={styles['rating-value']}>{ratingSummary?.rating}</span>
      <StarSolidIcon className={styles['rating-star']} />
      <div
        className={styles['rating-bar']}
        onClick={handleClick}
        onKeyDown={handleClick}
        role="button"
        tabIndex={0}
      >
        <span
          className={styles['rating-bar-fill']}
          style={{
            width: `${fillPercentage}%`
          }}
        />
      </div>
      <span className={styles['rating-count']}>{ratingCount}</span>
    </div>
  );
}

export default StarBarRatingItem;
